/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown>, range: NonNullable<unknown>, sessions: NonNullable<unknown> }} Wrapped_Period_Share_CoverInputs */

const en_us2_wrapped_period_share_cover = /** @type {(inputs: Wrapped_Period_Share_CoverInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`I closed ${i?.range} with ${i?.sessions} on My Pocket Gym.`);
	return /** @type {LocalizedString} */ (`I closed ${i?.range} with ${i?.sessions} on My Pocket Gym.`)
	
};

const pt_br2_wrapped_period_share_cover = /** @type {(inputs: Wrapped_Period_Share_CoverInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Fechei ${i?.range} com ${i?.sessions} no My Pocket Gym.`);
	return /** @type {LocalizedString} */ (`Fechei ${i?.range} com ${i?.sessions} no My Pocket Gym.`)
	
};

const es_419_wrapped_period_share_cover = /** @type {(inputs: Wrapped_Period_Share_CoverInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Cerré ${i?.range} con ${i?.sessions} en My Pocket Gym.`);
	return /** @type {LocalizedString} */ (`Cerré ${i?.range} con ${i?.sessions} en My Pocket Gym.`)
	
};

const pt_pt2_wrapped_period_share_cover = /** @type {(inputs: Wrapped_Period_Share_CoverInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Fechei ${i?.range} com ${i?.sessions} no My Pocket Gym.`);
	return /** @type {LocalizedString} */ (`Fechei ${i?.range} com ${i?.sessions} no My Pocket Gym.`)
	
};

const fr_fr2_wrapped_period_share_cover = /** @type {(inputs: Wrapped_Period_Share_CoverInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`J'ai bouclé ${i?.range} avec ${i?.sessions} sur My Pocket Gym.`);
	return /** @type {LocalizedString} */ (`J'ai bouclé ${i?.range} avec ${i?.sessions} sur My Pocket Gym.`)
	
};

const de_de2_wrapped_period_share_cover = /** @type {(inputs: Wrapped_Period_Share_CoverInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ich habe ${i?.range} mit ${i?.sessions} bei My Pocket Gym abgeschlossen.`);
	return /** @type {LocalizedString} */ (`Ich habe ${i?.range} mit ${i?.sessions} bei My Pocket Gym abgeschlossen.`)
	
};

const it_it2_wrapped_period_share_cover = /** @type {(inputs: Wrapped_Period_Share_CoverInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ho chiuso ${i?.range} con ${i?.sessions} su My Pocket Gym.`);
	return /** @type {LocalizedString} */ (`Ho chiuso ${i?.range} con ${i?.sessions} su My Pocket Gym.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "I closed {range} with {sessions} on My Pocket Gym." |
* | * | "I closed {range} with {sessions} on My Pocket Gym." |
*
* @param {Wrapped_Period_Share_CoverInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_share_cover = /** @type {((inputs: Wrapped_Period_Share_CoverInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Share_CoverInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_share_cover(inputs)
	if (locale === "es-419") return es_419_wrapped_period_share_cover(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_share_cover(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_share_cover(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_share_cover(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_share_cover(inputs)
	return en_us2_wrapped_period_share_cover(inputs)
});
export { wrapped_period_share_cover as "wrapped-period.share_cover" }